import React from 'react';
import { customTagColor, tagColor, tagTypeArr } from '../_config/constant';
import './index.scss'

export default function EventTypeTag(props: any) {
  const { eventType, title, count = 0, customColor, style = {}, isShowCount = true,}= props; 
   // tagColor?.length -1 自定义超过五个则都用第五个颜色
   const type = eventType?.toLowerCase();
  let colorTag =  customColor ? customColor : tagColor?.[type]
  return <div className={"event-type-tag"} style={{ ...style, }}>
    <span
      className={"event-type-tag-text"}
      style={{
        background: colorTag?.background
      }}
      title={title}
    >
      <span style={{ color: colorTag?.fontColor,opacity: 1}}>{title}</span>
    </span>
    {
      isShowCount && <span className={"event-type-tag-count"}>{count}</span>
    }

  </div>
}
